import StripeCardForm from './stripe-card-form'

export default StripeCardForm
